export default __webpack_public_path__ + "static/media/programming.76d405a8.svg";